import 'regenerator-runtime/runtime';
import { SagaIterator } from 'redux-saga';
import { put, select, takeLeading } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { hasUnvisitedOffer, isAdoptionReady, isPricingSettled } from '../models/angebotAdoption';
import { TgvActions } from '../tgvActions';
import { readAngebotOffers } from './angebotOffersReader';

export function* watchAngebotAdopt(): SagaIterator {
  yield takeLeading(TgvActions.TGV_ANGEBOT_ADOPT_REQUESTED, safeSaga(angebotAdoptSaga, App.TGV));
}

export function* angebotAdoptSaga(): SagaIterator {
  const state: IAppState = yield select();
  const offers = readAngebotOffers(state);
  const { transientState } = state;
  if (hasUnvisitedOffer(offers, transientState.angebot)) {
    yield put(new TgvActions().angebotAdoptionBlocked());
    return;
  }
  if (isAdoptionReady(offers, transientState)) {
    yield put(new TgvActions().insDashboardClicked());
    return;
  }
  PS20Logger.info(
    'TGV_ANGEBOT_ADOPT_NOT_READY',
    offers.length > 0 && isPricingSettled(offers, transientState)
      ? 'The take-over was requested but a Linie other than the selected one has no price'
      : 'The take-over was requested but the group is empty, not fully priced or a child is busy',
    App.TGV,
  );
}
